// extracted by mini-css-extract-plugin
export default {"container":"auth_container__VDeV0","auth_container":"auth_auth_container__2aFIo","img_side":"auth_img_side__ftIjs","form_cont":"auth_form_cont__j3QUp"};